import { cx } from "class-variance-authority";
import { extendTailwindMerge } from "tailwind-merge";
//#region src/utils/classnames.ts
const twMerge = extendTailwindMerge({ extend: { classGroups: { shadow: [{ elevation: [
	"none",
	"1",
	"2",
	"3",
	"4"
] }] } } });
const cn = (...inputs) => twMerge(cx(inputs));
//#endregion
export { cn };

//# sourceMappingURL=classnames.js.map